export const formatValue = (value, max) => (value === max ? `${value}+` : String(value));
